import * as types from './meetings.types';

export const meetingsPageSelectors: types.IMeetingsPageSelectors = {
  selectReducedMeetings: (state) => state.page.meetings.reducedMeetings,
  selectStartedMeetings: (state) => state.page.meetings.startedMeetings,
  selectFilteredMeetings: (state) => state.page.meetings.filteredMeetings,
  selectCurrentMeeting: (state) => state.page.meetings.currentMeeting,
  selectIsFetched: (state) => state.page.meetings.isFetched,
};
